import { createSelector } from '@ngrx/store';

import { getTeamsState } from './main.selectors';

export const getTeams = createSelector(getTeamsState, (data) => data || []);
